import { authRoles } from 'app/auth';
import DeviceTypeTable from './table/DeviceTypeTable';
import DeviceTypeEditForm from './editform/DeviceTypeEditForm';

export default [
	{
		path: '/device-type/edit/:id',
		component: DeviceTypeEditForm,
		auth: authRoles.deviceType
	},
	{
		path: '/device-type/:sessionNameParam?',
		component: DeviceTypeTable,
		auth: authRoles.deviceType
	}
];
